<template>
  <div class="container pb-4 mb-4">

    <div class="row pb-2">
        <div class="col">
          <h5>Accounts</h5>
        </div>
    </div>

        <div class="card">
          <div class="card-body pb-2">
            
      <div v-if="loading" class="text-center pb-3"><i class="fas fa-spinner fa-spin"></i></div>
      <div v-else-if="users.length == 0" class="text-center pb-3">No transactions</div>

        <span v-else>

        

        <!-- Desktop -->
        <table class="table d-none d-md-table">
              <thead class="thead-dark">
                <tr>
                  <th class="first-left pl-3">ID</th>
                  <th class="pl-3">Name</th>
                  <th class="pl-3">Country</th>
                  <th class="pl-3">Email</th>
                  <th class="pl-3">Balance</th>
                  <th class="first-right pl-3">Registered</th>
                </tr>
              </thead>
              <tbody>
                <tr class="body" v-for="(user, index) in users" :key="index" @click="openlink(user.id)">
                    <td class="pl-3">{{ user.id }}</td>
                    <td class="pl-3">{{`${user.name} ${user.surname}`}}</td>
                    <td class="pl-3"><img 
                    v-if="user.country"
                    :src="'/images/flags/svg/'+getFlag(user.country)" 
                    class="country_flag" 
                    :title="user.city+' - '+user.country+' - '+user.ip"></td>
                    <td class="pl-3">{{ user.email }}</td>
                    <td class="pl-3"><span :class="user.balance > 0 ? 'debit' : ''">{{ formattedPrice(user.balance) }}</span></td>
                    <td class="pl-3"><timeago
                    :datetime="user.created_at"
                    :auto-update="60"
                    :title="formatDateMoment(user.created_at)"></timeago>
                    </td>
                </tr>
              </tbody>
            </table>

        <!-- Mobile -->
        <table class="table d-md-none">
            <thead class="thead-dark">
                <tr>
                  <th class="first-left first-right text-center">Name • Country • Registered</th>
                </tr>
              </thead>
          <tbody>
            <tr v-for="(user, index) in users" :key="index">
  
        <td class="pl-2">
            <div>{{ user.name }} {{ user.surname }}</div>
            <div>{{`${user.city} - ${user.country}`}}</div>
            <div><timeago
                  :datetime="user.created_at"
                  :auto-update="60"
                  :title="formatDateMoment(user.created_at)"></timeago></div>
        </td>

            </tr>
          </tbody>
        </table>

        </span>

          </div>
        </div>

  </div>
</template>

<script>
export default {
  props: ['total_balance'],

  data() {
    return {
      users: [],
      loading: false,
      balance_class: 'owing',
    };
  },

  created() {
    this.getUsers();
  },

  methods: {
    openlink(id) {
      if (id) {
        window.open(`/accounts/view/${id}`, '_self');
      }
    },

    getUsers() {

      this.loading = true;

      axios
        .get('/accounts/list')
        .then((response) => {
          this.users = response.data;
          this.loading = false;
        })
        .catch(function (error) {
          console.log(error);
          this.loading = false;
        });
    },

  },
};
</script> 